export * from '@dojo/shim/support/queue';
